import { makeStyles } from "@material-ui/core";

export const permissionDeniedModalStyle = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus-visible": {
      outline: "none !important",
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: theme.spacing(1),
    "&:focus-visible": {
      outline: "none !important",
    },
  },
  bodyWrapper: {
    padding: "20px",
    textAlign: "center",
    outline: "none !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "400px",
    color: "var(--dark_blue)",
    "&: focus-visible": {
      outline: "none !important",
    },
  },
  closeButton: {
    border: 'none',
    cursor:'pointer',
    padding: '4px 15px !important',
    minWidth: "75px !important",
    minHeight:'30px !important',
    borderRadius:'4px !important',
    textTransform: 'capitalize !important',
    color: '#ffffff !important',
    fontWeight:"600 !important",
    backgroundColor: "var(--accent-color) !important",
    "&:focus, &:hover": {
      color: '#ffffff !important',
      backgroundColor: "var(--accent-color) !important",
    },
  },
}));
